<template>
  <div>
    <!-- 标题 -->
    <h3>发票/付款计划</h3>
    <Row style="margin-top: 10px">
      <Col :span="8">项目名称: {{ data.projectName }}</Col>
      <Col :span="12">合同名称: {{ data.name }}</Col>
    </Row>
    <Row style="margin-top: 10px">
      <Col :span="8">合同金额: {{ data.totalMoney }}</Col>
      <Col :span="8">已开票占比: {{ data.totalProportion }}%</Col>
      <Col :span="8">剩余待开: {{ data.needMoney }}</Col>
    </Row>
    <!-- TAB目录 -->
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="menus && menus.length > 0"
    >
      <Menu
        mode="horizontal"
        :active-name="menu_name"
        @on-select="selectMenu"
        style="width: 100%"
      >
        <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
          <MenuItem
            :name="v.name"
            v-auth="v.auth"
            @click="v.onClick"
            v-show="v.show === true ? false : true"
          >
            <Badge
              :overflow-count="10000000"
              v-if="v.badge && v.badge.count"
              :count="v.badge.count"
              :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>

    <!-- 操作 -->
    <Row
      :gutter="8"
      style="margin: 10px 0 0 0; width: 100%"
      v-if="actions && actions.length > 0"
    >
      <div
        v-for="(v, k) in actions"
        :key="k"
        style="margin-right: 10px; display: inline-flex"
      >
        <Button
          :size="v.size || 'default'"
          :type="v.type || 'warning'"
          v-auth="v.auth"
          :icon="v.icon || ''"
          @click="v.onClick"
          >{{ v.label }}
        </Button>
      </div>
    </Row>

    <!-- 表格 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <edit-table
        ref="tablelist"
        :query="query"
        :table="table"
        :order="table.order || ''"
        :rowClassName="table.rowClassName"
        :output="table.output"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        :handleSpan="handleSpan"
        @on-select="handleSelect"
        @on-edit="handleEdit"
        @on-info="handleInfo"
        @on-del="handleDel"
      >
        <div slot="action" v-if="tactions && tactions.length > 0">
          <div
            v-for="(v, k) in tactions"
            :key="k"
            style="margin-right: 10px; display: inline-flex"
          >
            <Button
              :size="v.size || 'default'"
              :type="v.type || 'primary'"
              v-auth="v.auth"
              :icon="v.icon || ''"
              :disabled="v.disabled"
              @click="v.onClick"
              >{{ v.label }}
            </Button>
          </div>
        </div>
      </edit-table>
      <!-- <Badge   v-if="hospitaltype=='购物车'" :count="num" style="margin-top: 50px" > <Button @click="handleSubmit" style="background: #00c261;color: #f8f8f9;">提交申请</Button></Badge> -->
    </Row>
    <!-- 侧栏详情 -->
    <Drawer title="详情" :closable="true" width="640" v-model="drawerBox">
      <component :is="drawerName" :kv="drawerKv"></component>
    </Drawer>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseList from "@/views/components/base/baseList.vue";
import config from "../../../../config";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "invoice",
        key: "id",
        url: {
          list: `/admin/system/invoice/list?contractId=${this.$route.query.id}`,
          del: "/admin/system/invoice",
          edit: "/admin/system/invoice",
        },
        output: false,
      },
      actions: [
        {
          label: "新建发票",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
        },
      ],
      menus: [],
      filters: [
        {
          label: "发票金额",
          KeyEnter: this.search,
          name: "invoicePrice",
          value: "",
          type: "input",
        },
        {
          label: "款项内容",
          KeyEnter: this.search,
          name: "paymentContent",
          value: "",
          type: "input",
        },
        {
          label: "发票状态",
          KeyEnter: this.search,
          name: "state",
          value: "",
          type: "select",
          dropList: [
            { value: 1, name: "待开票" },
            { value: 2, name: "已开票" },
            // { value: 3, name: "发票退回" },
            { value: 4, name: "移交财务" },
            { value: 5, name: "已支付" },
          ],
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "发票金额(元)",
          key: "invoicePrice",
          minWidth: 60,
          align: "center",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row;
            const budget = row.invoicePrice;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "付款占比",
          key: "paymentProportion",
          minWidth: 60,
          align: "center",
          tooltip: "true",
          render: (h, params) => {
            const row = params.row.paymentProportion.toFixed(2);
            return <div>{row}%</div>;
          },
        },
        {
          title: "款项内容",
          key: "paymentContent",
          minWidth: 200,
          align: "left",
        },
        {
          title: "付款要求",
          key: "paymentRequirements",
          minWidth: 100,
          align: "center",
          tooltip: "true",
        },
        {
          title: "发票状态",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "待开票"
                : row.state === 2
                ? "已开票"
                : // : row.state === 3
                // ? "发票退回"
                row.state === 4
                ? "移交财务"
                : row.state === 5
                ? "已支付"
                : "";
            return h(
              "div",
              {
                style: {
                  color: row.state == 5 ? "green" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "发票文件",
          key: "invoiceUrl",
          minWidth: 40,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.invoiceUrl !== null) {
              const text = row.invoiceUrl;
              return (
                <svg
                  onClick={() => {
                    this.handleRender(text);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "附件",
          minWidth: 30,
          align: "center",
          key: "remarkUrl",
          render: (h, params) => {
            const row = params.row;
            if (row.remarkUrl !== null) {
              const text = row.remarkUrl;
              return (
                <svg
                  onClick={() => {
                    this.handleRender(text);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          fixed: "right",
          render: (vm, param) => {
            const row = param.row;
            return (
              <div>
                <Button
                  size="small"
                  onClick={() => this.toEdit(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  编辑
                </Button>
                <Button
                  size="small"
                  onClick={() => this.delItem(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  删除
                </Button>
              </div>
            );
          },
        },
      ],
      data: {},
    };
  },
  created() {
    let contractId = this.$route.query.id;
    this.initDatas(contractId);
  },
  methods: {
    handleRender(text) {
      if (!text) {
        $utils.toast.error("暂无文件!");
        return;
      }
      const texturl = text.split(",").map((url) => config.IMAGE_HOST + url);
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "500px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              {files.map((item, i) => (
                <div
                  style="display:flex;justify-content: space-between;border: 1px solid #dcdee2; padding: 10px;border-radius: 5px;"
                  key={i}
                >
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                </div>
              ))}
            </div>
          );
        },
      });
    },
    initDatas(id) {
      // 加载详情数据
      $utils.api.load(`/admin/system/contract/${id}`, {}).then((res) => {
        if (res && res.data) {
          const totalMoney = res.data.totalMoney;
          const needMoney = res.data.needMoney;
          res.data.totalMoney = new Intl.NumberFormat("zh-CN", {
            style: "currency",
            currency: "CNY",
          }).format(totalMoney);
          res.data.needMoney = new Intl.NumberFormat("zh-CN", {
            style: "currency",
            currency: "CNY",
          }).format(needMoney);
          this.data = res.data;
        }
      });
    },
    toAdd() {
      $utils.url.push({
        name: "add_contractInvoice",
        query: { action: "add", id: this.$route.query.id },
      });
    },
    toEdit(row) {
      $utils.url.push({
        name: "add_contractInvoice",
        query: { action: "edit", id: row.id },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(`/admin/system/invoice/${row.id}`, d, "DELETE");
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.search();
        }, 100);
      }
    },
  },
};
</script>

<style></style>
